

























import { Component, Vue } from "vue-property-decorator";
import { Notice, Readnotice, Deletenotice } from "@/req/user";
@Component
export default class Logout extends Vue {
  public contextMenuVisible = false;
  public contextMenuTarget = "";
  public noticeData: any = []; // 通知内容
  public page = 1;
  public pageSize = 10;
  public isLoading = false;
  public getScroll(event) {
    const scrollBottom =
      event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight <=
      50;
    if (scrollBottom && this.isLoading == false) {
      this.isLoading = true;
      this.page++;
      this.messNotice();
    }
  }
  public show() {
    this.page = 1;
    this.noticeData = [];
    this.isLoading = false;
    this.messNotice();
  }

  // 通知
  public async messNotice() {
    const obj = {
      token: this.$fn.cookies.getToken(),
      size: this.pageSize,
      page: this.page,
    };
    const res = await Notice(obj);
    if (this.page === 1) {
      this.noticeData = res.data.noticeData.data;
      if (this.page == res.data.noticeData.last_page) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    } else {
      this.noticeData = [...this.noticeData, ...res.data.noticeData.data];
      if (this.page === res.data.noticeData.last_page) {
        this.isLoading = true;
      } else {
        this.isLoading = false;
      }
    }
  }
  // 通知状态更改
  public async changeNotice(i, id, index, read) {
    if (read) return;
    const obj = {
      token: this.$fn.cookies.getToken(),
      system_id: i,
      sender_id: id,
    };
    const res = await Readnotice(obj);
    if (res.code == 200) {
      this.noticeData[index].is_read = 1;
    }
  }
}
